import styled from "styled-components";

export const AreaCardList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  max-width: 800px;
`;

export const AreaCard = styled.div`
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.3s ease;

  &:hover {
    border-color: var(--accent);
  }
`;

export const AreaCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

export const AreaCardName = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--accent-secondary);
  margin: 0;
`;

export const AreaCardBbox = styled.p`
  font-size: 0.85rem;
  color: var(--text-heading);
  margin: 0 0 0.5rem 0;
  font-family: monospace;
`;

export const AreaCardStatus = styled.p`
  font-size: 0.9rem;
  color: var(--text-heading);
  margin: 0 0 1rem 0;
`;

export const AreaCardActions = styled.div`
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const RiskBadge = styled.span`
  background: color-mix(in srgb, var(--danger) 30%, transparent);
  color: var(--danger);
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
`;

export const OkBadge = styled.span`
  background: var(--accent-soft);
  color: var(--accent);
  padding: 0.25rem 0.6rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
`;

export const EmptyState = styled.p`
  color: var(--text-heading);
  font-size: 1rem;
  text-align: center;
  padding: 3rem;
`;
